// extracted by mini-css-extract-plugin
export var body = "_gj-5";
export var closeButton = "_gj-f";
export var container = "_gj-1";
export var content = "_gj-2";
export var cta = "_gj-c";
export var ctaLabel = "_gj-b";
export var eyebrow = "_gj-3";
export var howTo = "_gj-6";
export var image = "_gj-e";
export var modal = "_gj-0";
export var socialButton = "_gj-d";
export var stepCard = "_gj-8";
export var stepLabel = "_gj-a";
export var stepNumber = "_gj-9";
export var steps = "_gj-7";
export var title = "_gj-4";